import { tabletMax } from '@propertypal/shared/src/constants/mediaQueries';
import { WHITE_400 } from '@propertypal/shared/src/styles/theme';
import platform from '@propertypal/shared/src/utils/platform';
import styled from 'styled-components';

export const Container = styled.div`
  padding: 15px;
  border: ${({ theme }) => platform.select(`2px solid ${theme.keyline}`, `1px solid ${WHITE_400}`)};
  border-radius: 10px;
  background-color: ${({ theme }) => theme.background};
  display: flex;
  color: ${({ theme }) => theme.textDark};
  margin: 30px 0;
  gap: 10px;
  align-items: center;

  img {
    height: 32px;
  }

  a {
    color: #ff6b00;
    text-decoration: underline;
  }

  @media (${tabletMax}) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export default Container;
